module.exports = __webpack_public_path__ + "img/location.e5805a6f.svg";